// Base URL of the Management Portal backend for whichever instance served this
// bundle. `https://management-server.repstor.com/` is substituted at container startup by
// the client image's env.sh, so this is the single source of truth for the API
// host — don't hardcode instance hostnames elsewhere.
export const apiUrl =
  window.location.href.indexOf("localhost") > 0
    ? "https://localhost:5001/"
    : "https://management-server.repstor.com/";

// The backend serves Swagger UI at the API root (Startup.cs sets
// RoutePrefix = string.Empty), so the docs URL is just the base URL.
export const swaggerUrl = apiUrl;
